import { render, staticRenderFns } from "./modal-check-order.vue?vue&type=template&id=cb2cb3ba&"
import script from "./modal-check-order.vue?vue&type=script&lang=js&"
export * from "./modal-check-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports